import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

class Loading extends React.Component {
    render() {
        return (
            <div className='text-center pt-3 pb-3'>
                <div>Loading</div>
                <FontAwesomeIcon icon={['far', 'spinner']} spin/>
            </div>
        );
    }
}

export default Loading;
